import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Card from './components/Card';
import experienceData from './data.js';

function App() {
  const experienceElements = experienceData.map(item => {
    return (
      <Card 
        key ={item.id}
        item={item}
      />

    )
  });

  return (
    <div className="App">
      <Navbar />
      <Hero/>
      <section className = "cards-list">
        {experienceElements}
      </section>
    </div>
  );
}

export default App;
